module.exports = __webpack_public_path__ + "img/student-second-prize-cn.f55fbba.png";